import styled from 'styled-components';
import theme from 'theme';

export const LoadingOverlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-color: ${theme.lightestGrey};
    opacity: 0.6;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 100;
`;
